<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="denyPcn.data" [valueSelected]="denyPcn.valueSelected"
                    (selectAnswer)="onRadioSelected($event, denyPcn)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="denyNoticeOwner.data" [valueSelected]="denyNoticeOwner.valueSelected"
                    (selectAnswer)="onRadioSelected($event, denyNoticeOwner)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <radio-question [data]="privateProperty.data" [valueSelected]="privateProperty.valueSelected"
                    (selectAnswer)="onRadioSelected($event, privateProperty)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <radio-question [data]="writesAfter.data" [valueSelected]="writesAfter.valueSelected"
                    (selectAnswer)="onRadioSelected($event, writesAfter)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">5</i>
    <radio-question [data]="companyContact.data" [valueSelected]="companyContact.valueSelected"
                    (selectAnswer)="onRadioSelected($event, companyContact)"></radio-question>
    <table class="experts-table">
      <tr>
        <td class="default-text">company name:</td>
        <td>
          <input aria-label=""  class="app-input" type="text" [(ngModel)]="company.name"
                 [disabled]="companyContact.valueSelected !== 'y'" />
        </td>
      </tr>
      <tr>
        <td class="default-text">address</td>
        <td>
          <input aria-label=""  class="app-input" type="text" [(ngModel)]="company.address1"
                 [disabled]="companyContact.valueSelected !== 'y'" />
        </td>
      </tr>
      <tr>
        <td class="default-text">address</td>
        <td>
          <input aria-label=""  class="app-input" type="text" [(ngModel)]="company.address2"
                 [disabled]="companyContact.valueSelected !== 'y'" />
        </td>
      </tr>
      <tr>
        <td class="default-text">address</td>
        <td>
          <input aria-label=""  class="app-input" type="text" [(ngModel)]="company.address3"
                 [disabled]="companyContact.valueSelected !== 'y'" />
        </td>
      </tr>
      <tr>
        <td class="default-text">address</td>
        <td>
          <input aria-label=""  class="app-input" type="text" [(ngModel)]="company.address4"
                 [disabled]="companyContact.valueSelected !== 'y'" />
        </td>
      </tr>
      <tr>
        <td class="default-text">postcode</td>
        <td>
          <input aria-label=""  class="app-input" type="text" [(ngModel)]="company.postcode"
                 [disabled]="companyContact.valueSelected !== 'y'" />
        </td>
      </tr>
      <tr>
        <td class="default-text">telephone number</td>
        <td>
          <input aria-label=""  class="app-input" type="text" [(ngModel)]="company.telephone"
                 [disabled]="companyContact.valueSelected !== 'y'" />
        </td>
      </tr>
    </table>
  </div>

  <div class="policy-item">
    <i class="policy-number">6</i>
    <radio-question [data]="legislation.data" [valueSelected]="legislation.valueSelected"
                    (selectAnswer)="onRadioSelected($event, legislation)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">7</i>
    <h5 [innerHTML]="textCopy.other_7_1"></h5>
    <div class="default-text" [innerHTML]="textCopy.other_7_2"></div>
    <br />
    <div class="default-text">
      <span>Your case is now in the hands of</span>
      <input aria-label=""  class="app-input inline" type="text" [(ngModel)]="enforcementAgents" />
      <span>who will contact you.</span>
    </div>
    <br />
    <div class="default-text" [innerHTML]="textCopy.other_7_3"></div>
    <div class="default-text" [innerHTML]="textCopy.other_7_4"></div>
    <br />
    <div class="default-text">
      <span>The</span>
      <input aria-label=""  class="app-input inline" type="text" [(ngModel)]="parkingAttendant"
             [disabled]="legislation.valueSelected !== '1'" />
      <span>took a photo of your vehicle.</span>
    </div>
    <br />
    <radio-question [data]="civilOfficer.data" [active]="legislation.valueSelected === '0'"
                    [valueSelected]="civilOfficer.valueSelected"
                    (selectAnswer)="onRadioSelected($event, civilOfficer)"></radio-question>
    <br />
    <radio-question [data]="payDisplayTicket.data" [valueSelected]="payDisplayTicket.valueSelected"
                    (selectAnswer)="onRadioSelected($event, payDisplayTicket)"></radio-question>
    <br />
    <radio-question [data]="parkingTicket.data" [valueSelected]="parkingTicket.valueSelected"
                    (selectAnswer)="onRadioSelected($event, parkingTicket)"></radio-question>
    <br />
    <radio-question [data]="postalPcns.data" [valueSelected]="postalPcns.valueSelected"
                    (selectAnswer)="onRadioSelected($event, postalPcns)"></radio-question>
    <br />
    <radio-question [data]="issuedPcn.data" [valueSelected]="issuedPcn.valueSelected"
                    (selectAnswer)="onRadioSelected($event, issuedPcn)"></radio-question>
    <br />
    <radio-question [data]="officerWatched.data" [valueSelected]="officerWatched.valueSelected"
                    (selectAnswer)="onRadioSelected($event, officerWatched)"></radio-question>
    <br />
    <radio-question [data]="photographicEvidence.data" [valueSelected]="photographicEvidence.valueSelected"
                    (selectAnswer)="onRadioSelected($event, photographicEvidence)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.other_7_12"></div>
    <textarea class="app-textarea" [(ngModel)]="photographicEvidenceOnline"
              [disabled]="photographicEvidence.valueSelected === '0'"></textarea>
    <br />
    <div class="default-text" [innerHTML]="textCopy.other_7_13"></div>
    <textarea class="app-textarea" [(ngModel)]="cctvEvidenceOnline"
              [disabled]="photographicEvidence.valueSelected === '0'"></textarea>
    <br />
    <radio-question [data]="personKeeper.data" [valueSelected]="personKeeper.valueSelected"
                    (selectAnswer)="onRadioSelected($event, personKeeper)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">8</i>
    <div *ngFor="let parkingArea of parkingAreas">
      <radio-question [data]="parkingArea.data" [valueSelected]="parkingArea.valueSelected"
                      (selectAnswer)="onParkingAreaSelect($event, parkingArea.id)"></radio-question>
    </div>
  </div>

  <div class="policy-item">
    <i class="policy-number">9</i>
    <h5 [innerHTML]="textCopy.other_9_1"></h5>
    <div class="default-text" [innerHTML]="textCopy.other_9_2"></div>
    <div class="default-text">
      <span>Your case comes under the</span>
      <input aria-label=""  class="app-input inline large" type="text" [(ngModel)]="legislations.example" [disabled]="true" />
    </div>
    <div class="default-text" [innerHTML]="textCopy.other_9_3"></div>
    <div class="default-text">
      <span>Your case comes under the</span>
      <input aria-label=""  class="app-input inline large" type="text" [(ngModel)]="legislations.busLane" />
    </div>
    <div class="default-text" [innerHTML]="textCopy.other_9_4"></div>
    <div class="default-text">
      <span>Your case comes under the</span>
      <input aria-label=""  class="app-input inline large" type="text" [(ngModel)]="legislations.moving" />
    </div>
    <div class="default-text" [innerHTML]="textCopy.other_9_5"></div>
    <div class="default-text">
      <span>Your case comes under the</span>
      <input aria-label=""  class="app-input inline large" type="text" [(ngModel)]="legislations.parking" />
    </div>
  </div>

  <div class="policy-item">
    <i class="policy-number">10</i>
    <radio-question [data]="contraventionExplanation.data" [valueSelected]="contraventionExplanation.valueSelected"
                    (selectAnswer)="onRadioSelected($event, contraventionExplanation)"></radio-question>
    <radio-question [data]="dontUnderstand.data" [active]="contraventionExplanation.valueSelected === 'n'"
                    [valueSelected]="dontUnderstand.valueSelected"
                    (selectAnswer)="onRadioSelected($event, dontUnderstand)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">11</i>
    <radio-question [data]="noticeOfRejection.data" [valueSelected]="noticeOfRejection.valueSelected"
                    (selectAnswer)="onRadioSelected($event, noticeOfRejection)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">12</i>
    <radio-question [data]="adjudicatorInformation.data" [valueSelected]="adjudicatorInformation.valueSelected"
                    (selectAnswer)="onRadioSelected($event, adjudicatorInformation)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">13</i>
    <div *ngFor="let stage of explainContraventionStages">
      <radio-question [data]="stage.data" [valueSelected]="stage.valueSelected"
                      (selectAnswer)="onExplainContraventionStagesSelect($event, stage.id)"></radio-question>
    </div>
  </div>

  <div class="policy-item">
    <i class="policy-number">14</i>
    <radio-question [data]="customiseColour.data" [valueSelected]="customiseColour.valueSelected"
                    (selectAnswer)="onRadioSelected($event, customiseColour)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">15</i>
    <radio-question [data]="discountedRate.data" [valueSelected]="discountedRate.valueSelected"
                    (selectAnswer)="onRadioSelected($event, discountedRate)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">16</i>
    <radio-question [data]="clickableLink.data" [valueSelected]="clickableLink.valueSelected"
                    (selectAnswer)="onRadioSelected($event, clickableLink)"></radio-question>
  </div>

  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
